import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  catBrands: [],
  loading: false,
  error: null,
};

const getCatBrandSlice = createSlice({
  name: "getCatBrand",
  initialState,
  reducers: {
    fetchCatBrandStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchCatBrandSuccess: (state, action) => {
      state.loading = false;
      state.catBrands = action.payload;
    },

    fetchCatBrandFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCatBrandStart,
  fetchCatBrandSuccess,
  fetchCatBrandFailure,
} = getCatBrandSlice.actions;

export default getCatBrandSlice.reducer;